import { Injectable } from '@angular/core'
import { ArtistId } from '../models/artist.model'
import { Observable } from 'rxjs'
import { PhysicalsByCustomer } from '../models/physicals-by-customer.model'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import * as moment from 'moment'

@Injectable({
  providedIn: 'root',
})
export class PhysicalsGraphService {
  constructor(private functions: AngularFireFunctions) {}

  findPhysicalsGraph(artistId: ArtistId, from: Date, to: Date): Observable<PhysicalsByCustomer[]> {
    return this.functions.httpsCallable<
      { artistId: string; from: string; to: string },
      PhysicalsByCustomer[]
    >('findPhysicalsGraph')({
      artistId,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
    })
  }
}
